<template>
  <div class="grasp-input__wrapper">
    <div class="input__prepend" v-if="$slots['prepend']">
      <slot name="prepend" />
    </div>
    <slot :updatingStatus="updatingStatus">
      <BaseFloatingLabel v-if="label" :label="label"></BaseFloatingLabel>
      <textarea
          :class="inputClasses"
          :disabled="disabled"
          :placeholder="placeholder"
          :value="modelValue"
          ref="textFieldRef"
          @input="updateValue($event)"
          style="font-size: inherit;"
          :style="height ? 'height:'+height : ''"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
      />
    </slot>
    <div class="grasp-textfield__append" v-if="$slots['append']">
      <slot name="append" />
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import { computed, nextTick, onMounted, ref, watchEffect } from 'vue';

export default {
  emits: ['update:modelValue', 'update', 'focus', 'blur'],
  props: {
    modelValue: {
      required: true,
    },
    height: String,
    type: String,
    placeholder: String,
    asynchronous: Boolean,
    bordered: {
      default: true,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    autoFocus: {
      default: false,
      type: Boolean
    },
      label: {
          default: null,
          type: String,
      },
  },
  setup(props, { emit }) {
    const updatingStatus = ref(null);
    const textFieldRef = ref(null);
    // const isResizing = inject('isResizing');

    onMounted(() => {
      if (!textFieldRef.value.value) {
        textFieldRef.value.value = props.placeholder;
      }
      // updateElementHeight(textFieldRef.value);
      textFieldRef.value.value = props.modelValue || null;
    });

    const inputClasses = computed(() => {
      let classes = 'grasp-input__input is-textfield'

      if(props.required) {
        classes += ' grasp-input__required'
      }

      if(props.bordered) {
        classes += ' grasp-textfield__bordered'
      }

      return classes
    })

    const updateValue = event => {
      const value = event.target.value;
      emit('update:modelValue', value);

      if (!props.asynchronous) return;
      return debouncedUpdate(value);
    };

    const debouncedUpdate = debounce(newValue => {
      updatingStatus.value = 'updating';
      new Promise((done, fail) => {
        emit('update', {
          value: newValue,
          done,
          fail,
        });
      })
          .then(() => {
            updatingStatus.value = 'success';
          })
          .catch(() => {
            updatingStatus.value = 'error';
          });
    }, 250);

    const focusInput = () => {
      textFieldRef.value.focus();
    };

    onMounted(async () => {
      if(props.autoFocus) {
        await nextTick()
        focusInput()
      }
    })

    watchEffect(
        () => props.modelValue,
        {
          flush: 'post',
        }
    );

    return {
      updateValue,
      updatingStatus,
      textFieldRef,
      focusInput,
      inputClasses
    };
  },
};
</script>
<style lang="scss">
.grasp-textfield {

  &__bordered {
    box-sizing: border-box;
    border: 1px solid var(--skeleton-color);
    border-radius: 5px;
    margin-bottom: 4px;
  }

  &__required::placeholder {
    opacity: 0.85;
  }

  &__append {
    display: flex;
    align-items: flex-start;
    margin-top: 8px;
  }

  //&__append, &__bordered {
  //  top: 8px;
  //}
}
</style>
